export const initialSubscriptionState = {
  shouldRefreshSubscriptions: false,
};

export const subscriptionActions = {
  setShouldRefreshSubscriptions: shouldRefreshSubscriptions => ({
    type: 'SET_SHOULD_REFRESH_SUBSCRIPTIONS',
    shouldRefreshSubscriptions,
  }),
};

export default (state, action) => {
  switch (action.type) {
    case 'SET_SHOULD_REFRESH_SUBSCRIPTIONS':
      return { ...state, shouldRefreshSubscriptions: action.shouldRefreshSubscriptions };
    default:
      return { ...state };
  }
};
